import React from 'react';
import ReactDOM from "react-dom";
import { IDuration } from "@talxis/base-controls";
import { Duration as DurationComponent } from "@talxis/base-controls";

interface IInputs {
    value: ComponentFramework.PropertyTypes.WholeNumberProperty;
}
interface IOutputs {
    value?: number;
}

export class Duration implements ComponentFramework.StandardControl<IInputs, IOutputs> {
    private _notifyOutputChanged: () => void;
    private _container: HTMLDivElement;
    private _outputs: IOutputs = {};

    constructor() { }

    public init(context: ComponentFramework.Context<IInputs>, notifyOutputChanged: () => void, state: ComponentFramework.Dictionary, container: HTMLDivElement) {
        this._notifyOutputChanged = notifyOutputChanged;
        this._container = container;
    }
    public updateView(context: ComponentFramework.Context<IInputs>): void {
        ReactDOM.render(React.createElement(DurationComponent, {
            context: context,
            parameters: {
                value: context.parameters.value
            },
            onNotifyOutputChanged: (outputs) => {
                this._outputs = outputs;
                this._notifyOutputChanged();
            }
        } as IDuration), this._container);
    }

    public getOutputs(): IOutputs {
        return this._outputs;
    }

    public destroy(): void {
        ReactDOM.unmountComponentAtNode(this._container);
    }
}